import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { useSiteContent } from "../data/content";

export default function Hero() {
  const content = useSiteContent();
  const { hero, images } = content;
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section id="top" className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-slate-50 via-white to-white" />
      <div className="absolute -z-10 top-0 right-0 w-[700px] h-[700px] bg-teal-100/40 blur-[120px] rounded-full" />
      <div className="absolute -z-10 top-40 -left-32 w-[500px] h-[500px] bg-blue-100/50 blur-[120px] rounded-full" />
      <div
        className="absolute inset-0 -z-10 opacity-[0.35]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(11,31,58,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(11,31,58,0.06) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
          maskImage:
            "radial-gradient(ellipse at center, rgba(0,0,0,0.9) 30%, transparent 75%)",
        }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 text-[12px] font-medium tracking-[0.18em] uppercase text-teal-700 bg-teal-50 border border-teal-100 px-3 py-1.5 rounded-full">
            <Sparkles className="w-3.5 h-3.5" />
            {hero.eyebrow}
          </span>
          <h1 className="mt-7 text-[44px] sm:text-[56px] lg:text-[72px] leading-[1.04] font-semibold tracking-[-0.03em] text-[#0B1F3A] whitespace-pre-line">
            {hero.title}
          </h1>
          <p className="mt-7 text-lg lg:text-xl text-slate-600 leading-relaxed max-w-2xl">
            {hero.subtitle}
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              onClick={() => go("kontakt")}
              className="group inline-flex items-center gap-2 bg-[#0B1F3A] hover:bg-[#102a4d] text-white px-6 py-3.5 rounded-lg text-[15px] font-medium transition-colors duration-200"
            >
              {hero.primaryCta}
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
            <button
              onClick={() => go("leistungen")}
              className="inline-flex items-center gap-2 text-[#0B1F3A] hover:text-teal-700 px-2 py-3.5 text-[15px] font-medium border-b border-slate-300 hover:border-teal-500 transition-colors duration-200"
            >
              {hero.secondaryCta}
            </button>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-6 max-w-xl">
            {hero.stats.map((s) => (
              <div key={s.label}>
                <div className="text-3xl lg:text-4xl font-semibold text-[#0B1F3A] tracking-tight">
                  {s.value}
                </div>
                <div className="text-xs lg:text-sm text-slate-500 mt-1 leading-snug">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-slate-900/10 ring-1 ring-slate-200">
            <img
              src={images.hero}
              alt={hero.title}
              className="w-full h-[460px] lg:h-[560px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#0B1F3A]/40 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -left-6 sm:-left-10 bg-white rounded-xl border border-slate-200 shadow-xl p-4 w-[260px]">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-teal-50 text-teal-700 flex items-center justify-center">
                <Sparkles className="w-5 h-5" />
              </div>
              <div>
                <div className="text-sm font-semibold text-[#0B1F3A]">
                  {hero.badge.title}
                </div>
                <div className="text-xs text-slate-500">{hero.badge.desc}</div>
              </div>
            </div>
            <div className="mt-3 h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full w-3/4 bg-gradient-to-r from-teal-400 to-teal-600 rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
